type SearchHistoryChipProps = {
  children: React.ReactNode;
  className?: string;
  currentExecutionId?: string;
  hoveredExecutionId?: string;
};

const SearchHistoryChip = ({ children, className, currentExecutionId, hoveredExecutionId }: SearchHistoryChipProps) => {
  return (
    <div
      className={`rounded-full px-2 py-0.5 max-md:px-1 ${currentExecutionId === hoveredExecutionId ? 'bg-base-200/30 text-white' : 'bg-base-200 group-hover:bg-base-100'} ${className}`}
    >
      {children}
    </div>
  );
};

export default SearchHistoryChip;
